import React from "react";
import { useSelector } from "react-redux";

const applyMode = (text, mode) => {
  switch (mode) {
    case "lower":
      return text.toLowerCase();
    case "capitalize":
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    case "title":
      return text.replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    case "upper":
      return text.toUpperCase();
    default:
      return text;
  }
};

const Msg = ({ phrase, mode, ...props }) => {
  const phrases = useSelector((state) => state.i18n.phrases);
  const key = (phrase || "").toString().trim();
  const rawText = phrases[key] || key;
  const text = applyMode(rawText, mode);

  return <span {...props}>{text}</span>;
};


export default Msg;